module.exports = __webpack_public_path__ + "static/assets/61544c8c1fd0a3af4973b300d10e873d.svg";